<template>
  <div class="pages">
    <h1>Pages</h1>
    This file will display instagram profile page

  </div>
</template>

<script>
import InflusightsService from '@/services/InflusightsService'
export default {
  name: 'instagram_id',
  data () {
    return {id: ' '}
  },
  props: {info: {type: Object}},
  mounted (info) {
    console.log('MOUNTED!:' + info)
    this.getInstagramId(info)
  },
  methods: {
    async getInstagramId (info) {
      console.log('FB PAGE Info' + info)
      const response = await InflusightsService.fetchInstagramId()
      this.id = response.id
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/InstagramConnect.vue